import {
  Box,
  IconButton, InputAdornment,
  List, ListItem,
  ListItemButton,
  ListItemText,
  Stack, TextField,
  Fade,
  Typography, Button
} from "@mui/material";
import {grey} from "@mui/material/colors";
import React, {useEffect, useState} from "react";
import {
  IconLoader,
  IconPlus,
  IconSearch, IconSettings,
  IconX
} from "@tabler/icons-react";
import {CreateLLMFineTunedModelModal} from "./components/CreateLLMFineTunedModelModal";
import {Link} from "react-router-dom";

const selectedItemStyle = {
  borderRadius: 0, bgcolor: "transparent",
}

export const SideMenuFT = ({project, models, model, setModel, setModels}) => {

  return (
    <Fade in={!!project} timeout={500}>
      <Stack direction={"column"} sx={{
        maxHeight: '100%',
        minWidth: "220px",
        maxWidth: "280px",
        width: "100%",
        borderRight: 1,
        pb: 0.5,
        bgcolor: "transparent",
        borderColor: "divider",
        overflowY: "auto",
      }}>

        <ModelsBlock project={project} model={model} setModel={setModel} models={models} setModels={setModels}/>
      </Stack>
    </Fade>
  )
}

const ModelsBlock = ({project, models, model, setModel, setModels}) => {
  const [openModal, setOpenModal] = useState(false);
  const [selectedModel, setSelectedModel] = useState(null);
  const [search, setSearch] = useState("");

  return (
    <>
      <CreateLLMFineTunedModelModal
        open={openModal}
        organization={project?.settings?.organization}
        selectedModel={selectedModel}
        handleClose={() => {
          setSelectedModel(null);
          setOpenModal(false);
        }}
        onSuccess={(newModel) => {
          setModels(prev => {
            const newValue = [...prev];
            const index = newValue.findIndex(item => item.id === newModel.id);
            if (index >= 0) {
              newValue[index] = newModel;
            } else {
              newValue.push(newModel);
            }
            return newValue;
          })
        }}
        onDelete={(id) => {
          if (model?.id === id) {
            setModel(null)
          }
          setModels(prev => {
            const newValue = [...prev].filter(model => model?.id !== id);
            return newValue;
          })
        }}
      />
      <ListBlock
        isOpen={true}
        title={"Models"}
        items={models?.filter(item => item?.name?.toLowerCase()?.includes(search?.toLowerCase())) || []}
        onCreate={() => setOpenModal(true)}
        search={search}
        onChangeSearch={(val) => setSearch(val)}
        mapItem={(item) => {
          const isSelected = item?.id === model?.id;

          let style = {
            border: 1,
            borderColor: "transparent",
            mb: 0.5,
            p: 0,
            px: 0.5,
            "&:hover > *": {opacity: 1},
          };
          if (isSelected) {
            style = {...style, ...selectedItemStyle};
          }

          return (
            <ListItem
              key={item?.id || item?.key}
              sx={style}
              className={`side-link ${isSelected ? 'active' : ''}`}
            >
              <ListItemButton
                sx={{
                  "&:hover": {bgcolor: "transparent"}
                }}
                component={Link}
                to={`/project/${project?.id}/fine-tuning/${item?.id}`}
                >
                <ListItemText
                  primary={item?.name}
                  primaryTypographyProps={{fontSize: 13}}
                />
              </ListItemButton>
              <IconButton
                size={"small"}
                sx={{opacity: 0}}
                onClick={() => {
                  setSelectedModel(item);
                  setOpenModal(true);
                }}
              >
                <IconSettings size={14} />
              </IconButton>
            </ListItem>
          )
        }}
      />
    </>
  )
}

export const ListBlock = ({items, title, mapItem, search, onChangeSearch, onCreate, isOpen}) => {
  const [open, setOpen] = useState(!!isOpen);
  const [pagination, setPagination] = useState(5);

  useEffect(() => {
    if (!open) {
      setPagination(5);
    }
  }, [open]);

  return (
    <Box
      className={"side-item"}
      sx={{
        // border: open ? 1 : 0,
        borderBottom: 1,
        borderColor: "rgba(220,228,234, 0.5)",
        // bgcolor: open ? "rgba(220,228,234, 0.3)" : "#FFF",
        p: 0.5,
        m: 0.5,
        mb: 0,
        borderRadius: open ? 0 : 0
      }}
    >
      <List sx={{py: 0, m: 0}}>
        <ListItem
          sx={{
            mb: open ? 0.5 : 0,
            p: 0, zIndex: 10,
            // "&:hover": {bgcolor: open ? "rgba(220,228,234, 0.5)" : "rgba(220,228,234, 0.3)"},
            "&:hover > .create-btn": {opacity: 1, bgcolor: "transparent"}
          }}
        >
          <ListItemButton
            sx={{p: 1, "&:hover": {bgcolor: "transparent"}}}
            onClick={() => setOpen(!open)}>
            <Typography sx={{color: "dark.main", fontWeight: "bold", fontSize: 12}}>{title}</Typography>
          </ListItemButton>
          <IconButton className={"create-btn"} size={"small"} onClick={onCreate}
                      sx={{zIndex: 100, opacity: open ? 1 : 0, color: "dark.main"}}>
            <IconPlus size={13}/>
          </IconButton>
        </ListItem>
        {
          open &&
          <Box sx={{px: 1}}>
            <TextField
              size={"small"}
              variant={"standard"}
              value={search}
              fullWidth
              placeholder={"Search"}
              onChange={(e) => onChangeSearch(e.target.value)}
              InputProps={{
                sx: {borderRadius: 0, mb: 1},
                startAdornment: <InputAdornment position="start">
                  <IconSearch size={14}/>
                </InputAdornment>,
                endAdornment: search ? <InputAdornment position="end">
                  <IconButton size={"small"} onClick={() => onChangeSearch("")}>
                    <IconX size={14}/>
                  </IconButton>
                </InputAdornment> : null
              }}
            />
          </Box>
        }
        {
          open && items?.slice(0, pagination)?.map(item => mapItem(item))
        }
      </List>
      {
        open && items?.length > 5 ?
          <>
            {
              items?.length > pagination ?
                <Button fullWidth onClick={() => setPagination(items?.length + 2)}
                        sx={{fontSize: 12, textTransform: "none", color: grey[700]}}>
                  <IconLoader size={14} style={{marginRight: 5}}/>
                  Show More
                </Button>
                : <Button fullWidth onClick={() => setPagination(5)}
                          sx={{fontSize: 12, textTransform: "none", color: grey[700]}}>
                  <IconLoader size={14} style={{marginRight: 5}}/>
                  Show Less
                </Button>

            }
          </> : null
      }
    </Box>
  )
}